import { StylingModel } from '../style/styling.model';
import { CoreStylingModel } from '../core/core-styling.model';
import { ButtonStylingModel } from '../button/button-styling.model';
export class FileUploaderStylingModel extends CoreStylingModel {
/**
 * Styling dropZone html element by StylingModel
 */
dropZone: StylingModel;
/**
 * Styling files html element by StylingModel
 */
files: StylingModel;
/**
 * Styling file html element by StylingModel
 */
file: StylingModel;
/**
 * Styling fileImage html element by StylingModel
 */
fileImage: StylingModel;
/**
 * Styling fileName html element by StylingModel
 */
fileName: StylingModel;
/**
 * Styling fileProgress html element by StylingModel
 */
fileProgress: StylingModel;
/**
 * Styling fileActions html element by StylingModel
 */
fileActions: StylingModel;
/**
 * Styling filesActions html element by StylingModel
 */
filesActions: StylingModel;
/**
 * Styling uploadFileButton html element by ButtonStylingModel
 */
uploadFileButton: ButtonStylingModel;
/**
 * Styling removeFileButton html element by ButtonStylingModel
 */
removeFileButton: ButtonStylingModel;
/**
 * Styling uploadFilesButton html element by ButtonStylingModel
 */
uploadFilesButton: ButtonStylingModel;
/**
 * Styling removeFilesButton html element by ButtonStylingModel
 */
removeFilesButton: ButtonStylingModel;
/**
 * @hidden
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);

    if (this.dropZone == null) { this.dropZone = new StylingModel(); }
    if (this.files == null) { this.files = new StylingModel(); }
    if (this.file == null) { this.file = new StylingModel(); }
    if (this.fileImage == null) { this.fileImage = new StylingModel(); }
    if (this.fileName == null) { this.fileName = new StylingModel(); }
    if (this.fileProgress == null) { this.fileProgress = new StylingModel(); }
    if (this.fileActions == null) { this.fileActions = new StylingModel(); }
    if (this.filesActions == null) { this.filesActions = new StylingModel(); }
    if (this.uploadFileButton == null) { this.uploadFileButton = new ButtonStylingModel(); }
    if (this.removeFileButton == null) { this.removeFileButton = new ButtonStylingModel(); }
    if (this.uploadFilesButton == null) { this.uploadFilesButton = new ButtonStylingModel(); }
    if (this.removeFilesButton == null) { this.removeFilesButton = new ButtonStylingModel(); }
  }
}

function FileUploaderStylingModel_tsickle_Closure_declarations() {
/**
 * Styling dropZone html element by StylingModel
 * @type {?}
 */
FileUploaderStylingModel.prototype.dropZone;
/**
 * Styling files html element by StylingModel
 * @type {?}
 */
FileUploaderStylingModel.prototype.files;
/**
 * Styling file html element by StylingModel
 * @type {?}
 */
FileUploaderStylingModel.prototype.file;
/**
 * Styling fileImage html element by StylingModel
 * @type {?}
 */
FileUploaderStylingModel.prototype.fileImage;
/**
 * Styling fileName html element by StylingModel
 * @type {?}
 */
FileUploaderStylingModel.prototype.fileName;
/**
 * Styling fileProgress html element by StylingModel
 * @type {?}
 */
FileUploaderStylingModel.prototype.fileProgress;
/**
 * Styling fileActions html element by StylingModel
 * @type {?}
 */
FileUploaderStylingModel.prototype.fileActions;
/**
 * Styling filesActions html element by StylingModel
 * @type {?}
 */
FileUploaderStylingModel.prototype.filesActions;
/**
 * Styling uploadFileButton html element by ButtonStylingModel
 * @type {?}
 */
FileUploaderStylingModel.prototype.uploadFileButton;
/**
 * Styling removeFileButton html element by ButtonStylingModel
 * @type {?}
 */
FileUploaderStylingModel.prototype.removeFileButton;
/**
 * Styling uploadFilesButton html element by ButtonStylingModel
 * @type {?}
 */
FileUploaderStylingModel.prototype.uploadFilesButton;
/**
 * Styling removeFilesButton html element by ButtonStylingModel
 * @type {?}
 */
FileUploaderStylingModel.prototype.removeFilesButton;
}

